import { isElement, isEmpty } from "lodash";
import {
    publish
} from "../../../01-helpers/event-manager";
import {
    HAMBURGER_CLICKED
} from "../../../02-const/event-names";

const
    moduleName = 'hamburger',
    baseCssClass = `js-${moduleName}`,

    elements = {
        base: Symbol('baseElement')
    },

    propertyNames = {
        id: Symbol('hamburgerId'),
    },

    selectors = {
        base: `.${baseCssClass}`
    },

    css = {
        show: `${moduleName}--boring`,
        hide: `${moduleName}--collapse`
    };

function bindEvents() {
    this[elements.base].addEventListener('click', clicked.bind(this));
}

function init() {
    this.isCollapsed = true;
}

function clicked(evt) {
    toggle.call(this);
    publish(HAMBURGER_CLICKED, { hamburgerId: this[propertyNames.id], isCollapsed: this.isCollapsed });
}

function toggle() {
    const hamburger = this[elements.base];
    if (this.isCollapsed) {
        hamburger.classList.add(css.show);
        hamburger.classList.remove(css.hide);
    } else {
        hamburger.classList.remove(css.show);
        hamburger.classList.add(css.hide);
    }
    this.isCollapsed = !this.isCollapsed;
}


export default class Hamburger {
    constructor(baseElement) {
        if (!isElement(baseElement)) {
            throw "Unable to create instance of hamburger, no base element has been provided";
        }
        this[elements.base] = baseElement;

        this[propertyNames.id] = baseElement.id;
        if (isEmpty(this[propertyNames.id])) {
            throw "hamburger must contain an id.";
        }

        bindEvents.call(this);

        init.call(this);
    }

    get id() {
        return this[propertyNames.id];
    }

    destroy() {
        this[elements.base].removeEventListener('click', clicked.bind(this));
    }
}
